export const NEW_ACCOUNT = 'addAnotherAccount';

export const INTERNAL_ERROR = 'INTERNAL_ERROR';

export const EXTERNAL_ERRORS = [
    {
        code: 'PAYMENTS-1012',
        type: 'loseBonus'
    },
    {
        code: 'PAYMENTS-1025',
        type: 'feeConfirmed'
    },
    {
        code: 'PAYMENTS-1027',
        type: 'depositConfirmed'
    },
    {
        code: 'PAYMENTS-1028',
        type: 'currencyConversion'
    },
    {
        code: 'PAYMENTS-1029',
        type: 'profitTaxConfirmed'
    },
    {
        code: 'PAYMENTS-1043',
        type: 'beneficialOwnerConfirmed'
    }
];

export const POST_MESSAGE_ERRORS = {
    REDIRECT_WINDOW_CLOSED: 'REDIRECT_WINDOW_CLOSED',
    LIGHTBOX_CLOSED: 'LIGHTBOX_CLOSED',
    LIGHTBOX_TIMED_OUT_10S: 'LIGHTBOX_TIMED_OUT_10S',
    LIGHTBOX_TIMED_OUT_10M: 'LIGHTBOX_TIMED_OUT_10M'
};

export const INITIATORS = {
    CASHIER: 'CASHIER',
    CASHIER_QD: 'CASHIER_QD'
};

export const NUVEI_REDIRECT_TYPE = 'jsnuvei';

export const CREDIT_CARD = 'creditCard';
